import { render, staticRenderFns } from "./audit-logs.vue?vue&type=template&id=170a474f&scoped=true&"
import script from "./audit-logs.vue?vue&type=script&lang=js&"
export * from "./audit-logs.vue?vue&type=script&lang=js&"
import style0 from "./audit-logs.vue?vue&type=style&index=0&id=170a474f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a474f",
  null
  
)

export default component.exports